import "./style.css";
import "../Catalog/style.css";
import BusinessBtmImg from "../../images/BusinessBottom.png";
import eduantsnest from "../../images/eduantsnest.gif";
import estimate from "../../images/estimate.gif";
import hosting from "../../images/hosting.gif";
import nodemaster from "../../images/nodemaster.gif";
import classroom from "../../images/class.gif";
import brandmain from "../../images/nodemasterweb.gif";
import brandcompany from "../../images/brandcompany.gif";
import brandservice from "../../images/skynet.gif";

import React, { useState, useEffect } from "react";
import CatalogPanel from "../../components/CatalogPanel";

const FALLBACK_IMAGES = [
  { label: 'nodemaster', alt: 'image1', src: nodemaster },
  { label: 'hosting', alt: 'image2', src: hosting },
  { label: 'classroom', alt: 'image3', src: classroom },
  { label: 'estimate', alt: 'image4', src: estimate },
  { label: 'eduantsnest', alt: 'image5', src: eduantsnest },
  { label: 'brandmain', alt: 'image6', src: brandmain },
  { label: 'brandcompany', alt: 'image7', src: brandcompany },
  { label: 'brandservice', alt: 'image8', src: brandservice },
];

export default function Business() {
  const [tab, setTab] = useState('intro'); // 'intro' | 'catalog'

  const [imageData, setImageData] = useState(FALLBACK_IMAGES);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    fetch('/api/slides')
      .then(res => res.json())
      .then(data => {
        if (data.success && data.slides && data.slides.length > 0) {
          setImageData(data.slides.map((s, i) => ({
            label: s.label,
            alt: `slide-${i}`,
            src: s.image_url,
          })));
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    let timer;
    if (!isHovering && tab === 'intro') {
      timer = setInterval(() => {
        setCurrentSlide(prev => (prev + 1) % imageData.length);
      }, 4000);
    } else {
      clearInterval(timer);
    }
    return () => clearInterval(timer);
  }, [isHovering, imageData.length, tab]);

  const handleMouseEnter = () => setIsHovering(true);
  const handleMouseLeave = () => setIsHovering(false);
  const handlePrevSlide = () => setCurrentSlide(prev => (prev === 0 ? imageData.length - 1 : prev - 1));
  const handleNextSlide = () => setCurrentSlide(prev => (prev + 1) % imageData.length);

  return (
    <div className="BusinessContents">
      <div className="HomeContainer">
        {/* 상단 텍스트 */}
        <div className="BusinessTopTxt">
          <h1>Developer Center</h1>
          <h1>ANTSNEST</h1>
          <p>ANTSNEST 그룹의 사업을 소개합니다.</p>
        </div>

        {/* 탭 */}
        <div className="BusinessTabs">
          <button
            type="button"
            className={'BusinessTab' + (tab === 'intro' ? ' active' : '')}
            onClick={() => setTab('intro')}
          >🏢 사업 소개</button>
          <button
            type="button"
            className={'BusinessTab' + (tab === 'catalog' ? ' active' : '')}
            onClick={() => setTab('catalog')}
          >📚 카탈로그 / CI</button>
        </div>

        {tab === 'intro' && (
          <>
            <div className="imgslider"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}>
              <button className="slider-arrow left" onClick={handlePrevSlide}>&lt;</button>
              {(() => {
                const MAX_VISIBLE = 8;
                const total = imageData.length;
                const cur = currentSlide % total;
                return imageData.map((image, index) => {
                  const diff = ((index - cur) % total + total) % total;
                  const dist = Math.min(diff, total - diff);
                  const visible = total <= MAX_VISIBLE || dist <= Math.floor(MAX_VISIBLE / 2);
                  if (!visible) return null;
                  let slot = diff <= Math.floor(MAX_VISIBLE / 2) ? diff : diff - total;
                  return (
                    <img
                      key={image.alt}
                      src={image.src}
                      alt={`Slide ${index}`}
                      style={{
                        transform: `rotateY(${slot * 45}deg) translateZ(400px) ${isHovering && index === cur ? "scale(1.3)" : ""}`,
                        transition: 'transform 1s ease',
                      }}
                    />
                  );
                });
              })()}
              <button className="slider-arrow right" onClick={handleNextSlide}>&gt;</button>
            </div>

            <div className="BusinessMidTxt">
              <h1>Software</h1>
              <p>
                <span>앤츠네스트</span>는 파트너사의 작은 의견에도 귀 기울이고,
                <br />
                파트너사의 성공을 위해 끊임없이 노력하는 기업이 되겠습니다.
              </p>
              <p>당신의 성공 파트너 앤츠네스트와 함께하세요.</p>
            </div>

            <div className="BusinessBottom">
              <img src={BusinessBtmImg} alt="" />
            </div>
          </>
        )}

        {tab === 'catalog' && <CatalogPanel />}
      </div>
    </div>
  );
}
